import { bostaHttp } from 'http.js';

export const getPickupLocations = (payload) => {
  return bostaHttp.get(`/sllr/pickup-locations`, payload);
};

export const fetchPickupLocation = (id) => {
  return bostaHttp.get(`/sllr/pickup-locations/${id}`);
};

export const createPickupLocation = (payload) => {
  return bostaHttp.post(`/sllr/pickup-locations`, payload);
};

export const editPickupLocation = ({ pickupLocationId, payload }) => {
  return bostaHttp.put(`/sllr/pickup-locations/${pickupLocationId}`, payload);
};

export const deletePickupLocation = ({ id }) => {
  return bostaHttp.delete(`/sllr/pickup-locations/${id}`);
};

export const setDefaultPickupLocation = (id) => {
  return bostaHttp.put(`/sllr/pickup-locations/${id}/default`);
};
